import { render } from "./pageNot.vue?vue&type=template&id=306e7a6b&scoped=true"
import script from "./pageNot.vue?vue&type=script&lang=js"
export * from "./pageNot.vue?vue&type=script&lang=js"

import "./pageNot.vue?vue&type=style&index=0&id=306e7a6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306e7a6b"]])

export default __exports__